import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import moment from 'moment';
import { connect } from "react-redux"
import { LineChart, Line, ResponsiveContainer, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

const AlertTrend = props => {

  const history = useHistory();

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'weekly', value: 'weekly' });
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));

  const [data, setData] = React.useState([]);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(true);

  const dateOptions = [
    { label: 'weekly', value: 'weekly' },
    { label: 'monthly', value: 'monthly' }
  ];

  const cData = [
    {name: 'Page A', uv: 400, pv: 2400, amt: 2000},
    {name: 'Page B', uv: 800, pv: 3400, amt: 1600},
    {name: 'Page C', uv: 900, pv: 2100, amt: 2200},
  ];

  const columns = [{
    dataField: 'slno',
    text: '#',
  },
  {
    dataField: 'scheduled_date',
    text: 'Scheduled date',
  }, 
  {
    dataField: 'total',
    text: 'Alert count',
  }, 
  ];

  const handleSubmit = () => {

    let data = {
      'start_date': startDate,
      'end_date': endDate,
      // property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_ALERTTREND, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data)
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Alert Trend | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Alert Trend</h3>
            {/* <Link className="btn btn-secondary" to="/activities/index">Back</Link> */}
          </div>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row">
                <div className="col">
                  <div className="">
                    <label className="label form-label">&nbsp;</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Set to..."
                        options={dateOptions}
                        value={selectedDateOption}
                        onChange={e => { 
                          if(e.value == 'weekly') {
                            setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'monthly') {
                            setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                            setSelectedDateOption(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">From</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={startDate} onChange={e => { 
                        setStartDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">To</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={endDate} onChange={e => { 
                        setEndDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary" onClick={() => { handleSubmit(); }}>Generate</button>
              </div>

            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <BootstrapTable striped
                bordered={false}
                noDataIndication={<p className="text-muted text-center pt-4">No data</p>}
                wrapperClasses="table-responsive" className="border border-danger" keyField='id' data={ data } columns={ columns } />
            </CardBody>
          </Card>

          {data.length > 0 &&
          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <ResponsiveContainer width="100%" height={300}>
                <LineChart className="chartWrap" 
                  data={data} 
                  margin={{ top: 25, right: 30, bottom: 25, left: 20 }}
                  style={{
                    // borderColor: 'red', borderWidth: 3, 
                    // width: '100%',
                    }}>
                  <Line type="monotone" strokeWidth={3} strokeDasharray={'2 2'} 
                    dataKey="total" stroke="#ff6600" />
                  <CartesianGrid stroke="#ccc" />
                  <XAxis dataKey="scheduled_date" 
                    // tick={({payload}) => 'payload.value'}
                    tickFormatter={(e) => {
                      return moment(e).format('DD MMM YYYY')
                    }}
                    />
                  <YAxis />
                  <Tooltip />
                </LineChart>
              </ResponsiveContainer>
            </CardBody>
          </Card>}

     </Container>

      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(AlertTrend)